/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import {
    Button,
    TextField,
    Select,
    MenuItem,
    SelectChangeEvent,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAddLocationMutation, useLazyGetLoactionIdQuery, useUpdateLoactionMutation } from "../../services/loaction";
import "react-phone-input-2/lib/bootstrap.css";

declare global {
    interface Window {
        initMap: () => void;
        google: any;
    }
}

const GOOGLE_API_KEY = "AIzaSyCES0pCZNW9kCYzWiq4g0oDvSjPQUAyLVY";

const AddLocation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const id = useParams()
    const locationId = id?.id as any
    console.log(locationId, id, "DATAA");


    const [getLocationById] = useLazyGetLoactionIdQuery();
    const [addLocation] = useAddLocationMutation();
    const [updateLocation] = useUpdateLoactionMutation();


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            latitude: "",
            longitude: "",
            radius: "",
            address: "",
            location_type: "",
            suggestion: ""
        },
        validationSchema: Yup.object({
            latitude: Yup.string().optional(),
            longitude: Yup.string().optional(),
            radius: Yup.string().required("Radius is required"),
            address: Yup.string().trim().optional(),
            location_type: Yup.string().trim().required("Location Type is required"),
        }),
        onSubmit: async (values) => {
            const body: any = {
                latitude: values.latitude,
                longitude: values.longitude,
                radius: values.radius,
                address: values.address,
                location_type: values.location_type,
                suggestion: values.suggestion
            };
            try {
                if (locationId == null) {

                    const response = await addLocation({ body }).unwrap();
                    console.log("Add location response:", response);
                    if (response?.status === 200) {
                        navigate("/location-intelligence");
                    }
                } else {

                    const response = await updateLocation({ body, id: locationId as any }).unwrap();
                    console.log("Update location response:", response);
                    if (response?.status === 200) {
                        navigate("/location-intelligence");
                    }
                }
            } catch (error) {
                console.log("API Error:", error);
            }
        },
    });

    // Load Google Maps JS API and render an interactive map to pick lat/lng
    useEffect(() => {
        let marker: any = null;
        let geocoder: any = null;

        const initMap = () => {
            const mapContainer = document.getElementById("map-picker");
            if (!mapContainer) return;

            const center = {
                lat: Number(formik.values.latitude) || 30.7136,
                lng: Number(formik.values.longitude) || 76.7070,
            };

            const map = new window.google.maps.Map(mapContainer, {
                center,
                zoom: 13,
            });

            marker = new window.google.maps.Marker({
                position: center,
                map,
                draggable: true,
            });

            const updateLatLng = (lat: number, lng: number) => {
                // Update lat/lng immediately
                formik.setValues({
                    ...formik.values,
                    latitude: lat.toString(),
                    longitude: lng.toString(),
                });
                // Reverse geocode to get address text for the selected location
                if (geocoder) {
                    geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
                        if (status === "OK" && Array.isArray(results) && results[0]?.formatted_address) {
                            formik.setFieldValue("address", results[0].formatted_address);
                        }
                    });
                }
            };

            geocoder = new window.google.maps.Geocoder();

            map.addListener("click", (e: any) => {
                const lat = e.latLng.lat();
                const lng = e.latLng.lng();
                marker.setPosition({ lat, lng });
                updateLatLng(lat, lng);
            });

            marker.addListener("dragend", (e: any) => {
                const lat = e.latLng.lat();
                const lng = e.latLng.lng();
                updateLatLng(lat, lng);
            });
        };

        if ((window as any).google?.maps) {
            initMap();
            return;
        }

        const existing = document.getElementById("google-maps-script");
        if (existing) {
            existing.addEventListener("load", initMap as any, { once: true } as any);
            return;
        }

        const script = document.createElement("script");
        script.id = "google-maps-script";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}`;
        script.async = true;
        script.defer = true;
        script.onload = initMap;
        document.body.appendChild(script);

        return () => {
            script.onload = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        if (locationId) {
            (async () => {
                try {
                    const resp = await getLocationById({ id: locationId }).unwrap();
                    const data = (resp as any)?.data || {};
                    formik.setValues({
                        latitude: data?.latitude?.toString() || "",
                        longitude: data?.longitude?.toString() || "",
                        radius: data?.radius?.toString() || "",
                        address: data?.address || "",
                        location_type: data?.location_type || "",
                        suggestion: data?.suggestion || ""
                    });
                } catch (e) {

                }
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationId]);

    return (
        <>
            <div className="main_title">
                <h1>{locationId ? "Edit Location" : "Add Location"}</h1>
                <p>
                    <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
                    <span onClick={() => navigate("/location-intelligence")}>
                        Location Intelligence
                    </span>{" "}
                    - {locationId ? "Edit" : "Add"} Location
                </p>
            </div>

            <div className="cards">
                <form className="form" onSubmit={formik.handleSubmit}>
                    <div className="gap_p">
                        <div className="control_group w_100">
                            <label>Select Location on Map</label>
                            <div id="map-picker" style={{ width: "100%", height: 450, borderRadius: 8 }} />
                            {/* Hidden fields to store latitude and longitude from selection */}
                            <input
                                type="hidden"
                                name="latitude"
                                value={formik.values.latitude}
                                onChange={formik.handleChange}
                            />
                            <input
                                type="hidden"
                                name="longitude"
                                value={formik.values.longitude}
                                onChange={formik.handleChange}
                            />
                        </div>

                        <div className="control_group w_33">
                            <label>Radius Trigger</label>
                            <TextField
                                name="radius"
                                placeholder="Enter radius"
                                hiddenLabel
                                fullWidth
                                value={formik.values.radius}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={Boolean(formik.touched.radius && formik.errors.radius)}
                                helperText={formik.touched.radius && formik.errors.radius}
                            />
                        </div>

                        <div className="control_group w_33">
                            <label>Location Type</label>
                            <TextField
                                name="location_type"
                                placeholder="Enter location type"
                                hiddenLabel
                                fullWidth
                                value={formik.values.location_type}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={Boolean(formik.touched.location_type && formik.errors.location_type)}
                                helperText={formik.touched.location_type && formik.errors.location_type}
                            />
                        </div>

                        <div className="control_group w_33">
                            <label>Suggestions</label>
                            <TextField
                                name="suggestion"
                                placeholder="Enter suggestions"
                                hiddenLabel
                                fullWidth
                                value={formik.values.suggestion}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={Boolean(formik.touched.suggestion && formik.errors.suggestion)}
                                helperText={formik.touched.suggestion && formik.errors.suggestion}
                            />
                        </div>


                    </div>

                    <div className="form_btn">
                        <Button
                            className="btn btn_primary"
                            type="submit"

                        >
                            {locationId ? "Update" : "Save"}
                        </Button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default AddLocation;
